import { Box, CircularProgress, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import DeleteConfirmationModal from "../../../Common/Modals/DeleteConfirmationModal";
import useSignableDocumentsTableConfig from "./hooks/useSignableDocumentsTableConfig";
import useSignableDocumentsTableData from "./hooks/useSignableDocumentsTableData";
import SignableDocumentsTablePageActions from "./components/SignableDocumentsTablePageActions";
import SignableDocumentsTable from "./components/SignableDocumentsTable";
import appFetch from "../../../../api/appFetch";
import { DisplayMessage } from "../../../../services/helpers";

const SignableDocumentsTablePage = ({ resources, accessibleMoboOutlets }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const history = useHistory();

  const { data, setData, isLoading, setSelectedOutlet, selectedOutlet } =
    useSignableDocumentsTableData(resources);

  const handleEdit = (id) => {
    history.push(`/signabledocuments/${id}`);
  };

  const handleDelete = (id) => {
    setDocumentToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const { tableTheme, columns, actions, options } =
    useSignableDocumentsTableConfig(
      resources,
      handleEdit,
      handleDelete,
    );

  const handleDocumentDelete = async () => {
    setData((data) => data.filter((d) => d.id !== documentToDelete));

    appFetch({
      url: `/api/mobopro/v1/signabledocuments/${documentToDelete}`,
      method: 'DELETE',
      onSuccess: () => {
        DisplayMessage(resources["SignableDocumentWasDeleted"], "success");
      }
    })

    setIsDeleteModalOpen(false);
  };

  const loaderClasses = `offcentered-loader ${
    isLoading ? "fadeIn" : "fadeOut"
  }`;
  const pageClasses = `mt-4 ${isLoading ? "fadeOut" : "fadeIn"}`;

  const onCloseDeleteModal = () => { 
    setIsDeleteModalOpen(false); 
    setDocumentToDelete(null);
  }

  return (
    <Box>
      <Box className="position-relative py-4">
        <Typography variant="h3">{resources["SignableDocuments"]}</Typography>

        <Box className={loaderClasses}>
          <CircularProgress />
        </Box>

        <Box className={pageClasses}>
          <SignableDocumentsTablePageActions
            resources={resources}
            selectedOutlet={selectedOutlet}
            setSelectedOutlet={setSelectedOutlet}
            accessibleMoboOutlets={accessibleMoboOutlets}
            isLoading={isLoading}
          />

          <SignableDocumentsTable
            resources={resources}
            tableTheme={tableTheme}
            data={data}
            columns={columns}
            actions={actions}
            options={options}
          />
        </Box>
      </Box>

      <DeleteConfirmationModal
        open={isDeleteModalOpen}
        onClose={onCloseDeleteModal}
        onConfirm={handleDocumentDelete}
        resources={resources}
        areYouSureMessage={resources["DeleteSignableDocumentConfirmation"]}
      />
    </Box>
  );
};

export default SignableDocumentsTablePage;
